/*eslint-disable no-constant-condition */
import { useState, useEffect, useCallback } from 'react';
import { Container, Row, Col, InputGroup } from 'react-bootstrap';
import FilterModal from '../../../../../../../../Admin/components/common/filter-modal/FilterModal';
import { SearchSVG } from '../../../../../../../img/GlobalSVG';
import TextInput from '../../../../../../../../Components/GenericInputText/TextInput';
import Lists from './Lists';
import Skeleton from 'src/Member/components/footer/Skeleton';
import AddButton from '../../../../../UserFormNew/components/AddButton';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from '../../../../../../../api/APIEndpoints';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import debounce from 'lodash.debounce';
import { useSelector } from 'react-redux';

const DoctorsPanel = ({
  //onSelectedEmpHandler,
  //blobOid,
  onSelectedDocHandler,
  onUnSelectedDocHandler,
  setDoctorAllData,
  //selectedEmployerData,
  //showEmployerOnly,
  //onUnSelectedEmpHandler,
  //selectedLocation,
  //setSelectedLocation,
  editAffiliatedRecords,
  facilityOIDProps,
  facilityTaxIdProps,
  selectedDoctor,
}) => {
  const { userData } = useSelector((state) => state.user);

  const cacheBuster = (url) => `${url}`;

  const [openDoctorMOdal, setOpenDoctorMOdal] = useState(false);
  const [doctorsAPIResponse, setDoctorsAPIResponse] = useState(null);
  const [doctorsData, setDoctorsData] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingPage, setLoadingPage] = useState(true);
  const [customError, setCustomError] = useState(false);
  //const [ dataFetching, setDataFetching ] = useState( false );
  let SearchDoctorsListResponse = null;
  let SearchDoctorsListDataResp = null;

  const debouncedCall = useCallback(
    debounce((currentVal) => setSearchText(currentVal), 500),
    [],
  );

  const onChangeDoctorsHandler = (e) => {
    //setDataFetching( true );
    setSearchString(e.target.value);
    debouncedCall(e.target.value);
    setCurrentPage(1);
  };

  const handleAddDoctors = (e, facilityOID) => {
    console.log('calling this');
    e.stopPropagation();
    setOpenDoctorMOdal(true);
    setDoctorsData([]);
    searchDoctorsList(searchText, currentPage, facilityOID);
  };

  const applyFilterHandler = () => {
    console.log(
      'doctor panel applyFilterHandler',
      doctorsData,
      facilityOIDProps,
    );
    if (doctorsData && doctorsData.length > 0 && facilityOIDProps) {
      const docAllObj = { [doctorsData[0].Oid]: doctorsData };
      console.log('docAllObj', docAllObj);
      let tempObj = { ...docAllObj };
      tempObj = Object.assign(tempObj, docAllObj);
      setDoctorAllData(tempObj);
    }

    const selectedDoctor = doctorsData.filter((doc) => doc.isChecked === true);
    const unSelectedDoctor = doctorsData.filter(
      (doc) => doc.isChecked === false,
    );
    onSelectedDocHandler(selectedDoctor, facilityOIDProps);
    if (unSelectedDoctor && unSelectedDoctor.length > 0) {
      onUnSelectedDocHandler(unSelectedDoctor);
    }

    /*if ( doctorsData && doctorsData.length > 0 && blobOid ) {
      const empAllObj = ( { [ doctorsData[ 0 ].BlkOfBusOid ]: doctorsData } );
      let tempObj = { ...employerAllData };
      tempObj = Object.assign( tempObj, empAllObj );
      setEmployerAllData( tempObj );
    }
    if ( !blobOid && doctorsData ) {
      console.log( 'all employer data when no Blob is passed on....', doctorsData );
      setEmployerAllData( doctorsData );
    }*/
    //const selectedEmployer = doctorsData.filter( ( emp ) => emp.isChecked == true );
    //const unSelectedEmployer = doctorsData.filter( ( emp ) => emp.isChecked == false );
    //console.log(typeof onUnSelectedEmpHandler)
    //onSelectedEmpHandler( selectedEmployer, blobOid );
    //unSelectedEmployer && unSelectedEmployer.length > 0 && onUnSelectedEmpHandler(unSelectedEmployer);
    //console.log('unSelectedEmployer', unSelectedEmployer, typeof onUnSelectedEmpHandler);
    //if ( unSelectedEmployer && unSelectedEmployer.length > 0 ) {
    /*unSelectedEmployer.forEach(e => {
        console.log('selectedLocation', employerAllData, selectedLocation, e);
      })*/
    //onUnSelectedEmpHandler( unSelectedEmployer );
    //}
    /*
    if ( selectedLocation && selectedLocation.hasOwnProperty( clientOid ) ) {
      const tempObj = { ...selectedLocation };
      delete tempObj[ clientOid ];
      setSelectedLocation( tempObj );
    }
    */

    setOpenDoctorMOdal(false);
    setSearchString('');
  };

  const selectChangeHandler = (e) => {
    console.log('selectChangeHandler doctorsData+++++', doctorsData);
    e.stopPropagation();
    const { name, checked } = e.target;
    if (name === 'select-all-doctor') {
      const tempDoc = doctorsData.map((d) => {
        return { ...d, isChecked: checked };
      });
      setDoctorsData(tempDoc);
    } else {
      const tempDoc = doctorsData.map((d) =>
        d.PhysicainOid === name ? { ...d, isChecked: checked } : d,
      );
      setDoctorsData(tempDoc);
    }
  };

  /*const getDoctorsData = ( facilityOid ) => {
    console.log('getDoctorsData facilityOid', facilityOid);
    setDoctorsData(responseObj)
  }*/

  const showMoreDoctorsData = () => {
    setCurrentPage(currentPage + 1);
  };

  const showMoreSearchDoctorsData = () => {
    setCurrentPage(currentPage + 1);
  };

  const searchDoctorsList = async (searchString, currPage, facilityOid) => {
    console.log('searchDoctorsList facilityOid', facilityOid);
    //setDataFetching( true );
    try {
      let strSearchKey = '';
      if (searchString && searchString.length > 0 && searchString.length < 3) {
        console.log('IF searchString length 0 and < 3');
        setDoctorsAPIResponse(null);
        setDoctorsData([]);
        setCustomError(false);
        setCurrentPage(1);
        setLoadingPage(false);
      } else if (searchString.length === 0) {
        console.log('in Else if searchString length = 0');
        setDoctorsAPIResponse(null);
        setDoctorsData([]);
        //setCurrentPage( 1 );
        getDoctorsData(facilityOid, currentPage);
      } else {
        if (searchString && searchString.length >= 3) {
          setLoadingPage(true);
          setCustomError(false);
          console.log('searchString length >= 3');
          strSearchKey = '/searchkey/' + searchString;
          console.log('strSearchKey========', strSearchKey);

          let resPageSize;
          if (userData?.UserType === 'Provider') {
            resPageSize = 5000;
          } else {
            resPageSize = 10;
          }

          SearchDoctorsListResponse = await axiosInstance.get(
            cacheBuster(
              APIEndpoints.getDoctorsListResources() +
                'pagenumber/' +
                currPage +
                '/pagesize/' +
                resPageSize +
                '/facilityoid/' +
                facilityOid +
                strSearchKey,
            ),
          );
          console.log(
            'SearchDoctorsListResponse=====',
            SearchDoctorsListResponse,
          );

          SearchDoctorsListDataResp = SearchDoctorsListResponse.data;

          if (
            SearchDoctorsListResponse.status ===
            HttpSuccessCodes.HTTP_SUCCESS_CODE_200
          ) {
            setDoctorsAPIResponse(SearchDoctorsListDataResp.Response);
            if (
              selectedDoctor &&
              selectedDoctor[facilityOid] &&
              selectedDoctor[facilityOid].length > 0
            ) {
              console.log('here=======', selectedDoctor[facilityOid]);
              SearchDoctorsListDataResp.Response.PhysicianViewDetails.forEach(
                (d) => {
                  selectedDoctor[facilityOid].forEach((s) => {
                    if (d.PhysicainOid === s.PhysicainOid) {
                      d.isChecked = true;
                    }
                  });
                },
              );
              setDoctorsData(
                SearchDoctorsListDataResp.Response.PhysicianViewDetails,
              );
            }

            if (currPage === 1) {
              setDoctorsData(
                SearchDoctorsListDataResp.Response.PhysicianViewDetails,
              );
            } else {
              setDoctorsData([
                ...doctorsData,
                ...SearchDoctorsListDataResp.Response.PhysicianViewDetails,
              ]);
            }
            setLoadingPage(false);
          }
        }
      }
      //setDataFetching( false );
    } catch (error) {
      console.log('error', error);
      //setDataFetching( false );
      setLoadingPage(false);
      setCustomError(true);
      setDoctorsData([]);
    }
  };

  const getDoctorsData = async (facilityOid, currPage) => {
    console.log('getDoctorsData facilityOid', facilityOid);
    //setDataFetching( true );
    try {
      setLoadingPage(true);
      setCustomError(false);
      const DoctorsListResponse = await axiosInstance.get(
        cacheBuster(
          APIEndpoints.getDoctorsListResources() +
            'pagenumber/' +
            currPage +
            '/pagesize/10/facilityoid/' +
            facilityOid,
        ),
      );

      const DoctorsListDataResp = DoctorsListResponse.data;

      if (
        DoctorsListResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200
      ) {
        console.log('DOCTORS LISTS RESPONSE', DoctorsListDataResp.Response);
        setDoctorsAPIResponse(DoctorsListDataResp.Response);
        if (
          selectedDoctor &&
          selectedDoctor[facilityOid] &&
          selectedDoctor[facilityOid].length > 0
        ) {
          console.log('here=======', selectedDoctor[facilityOid]);
          DoctorsListDataResp.Response.PhysicianViewDetails.forEach((d) => {
            selectedDoctor[facilityOid].forEach((s) => {
              if (d.PhysicainOid === s.PhysicainOid) {
                d.isChecked = true;
              }
            });
          });
          setDoctorsData(DoctorsListDataResp.Response.PhysicianViewDetails);
        }

        if (currPage === 1) {
          setDoctorsData(DoctorsListDataResp.Response.PhysicianViewDetails);
        } else {
          setDoctorsData([
            ...doctorsData,
            ...DoctorsListDataResp.Response.PhysicianViewDetails,
          ]);
        }

        setLoadingPage(false);
      }
      //setDataFetching( false );
    } catch (error) {
      //setDataFetching( false );
      setLoadingPage(false);
      setCustomError(true);
      setDoctorsData([]);
    }
    //try {
    ////setLoadingPage( true );
    //let employerSelectedData = [ employerAllData ].map( item => ( item[ blobId ] || null ) ).filter( e1 => e1 !== null );

    //if ( !blobId ) {
    ////employerSelectedData = employerAllData.filter( e => e.isChecked === true );
    //employerSelectedData = employerAllData;
    //}

    //if ( employerSelectedData.length > 0 ) {
    //setLoadingPage( false );
    //setCustomError( false );
    //if ( blobId ) {
    //setEmployerData( employerSelectedData[ 0 ] );
    //}
    //if ( !blobId ) {
    //setEmployerData( employerSelectedData );
    //}
    //} else {
    //let apiUrl = APIEndpoints.getEmployerListResources() + 'pagesize/5000/';
    //if ( blobId ) {
    //apiUrl = apiUrl + 'blkofbusoid/' + blobId;
    //}
    //const EmployerListResponse = await axiosInstance.get(
    //cacheBuster( apiUrl ),
    //);
    //if ( EmployerListResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ) {
    //setLoadingPage( false );
    //setCustomError( false );

    //if ( EmployerListResponse?.data?.Response?.Client ) {
    //if(selectedEmployerData && selectedEmployerData[blobId] && selectedEmployerData[blobId].length > 0) {
    //const employerList = EmployerListResponse?.data?.Response?.Client
    //const tempObj = employerList
    //.map(item =>  selectedEmployerData[blobId]
    //.filter( selectedItem => Boolean(selectedItem.ClientId === item.ClientId))
    //.length ?
    //{...item, "isChecked": true}
    //: item);
    //setEmployerData(tempObj)

    //} else if(selectedEmployerData && !selectedEmployerData[blobId] && selectedEmployerData.length > 0) {
    //const employerList = EmployerListResponse?.data?.Response?.Client
    //const tempObj = employerList
    //.map(item =>  selectedEmployerData
    //.filter( selectedItem => Boolean(selectedItem.ClientId === item.ClientId))
    //.length ?
    //{...item, "isChecked": true}
    //: item);
    //setEmployerData(tempObj)
    //}
    //else {
    //setEmployerData( EmployerListResponse?.data?.Response?.Client );
    //}
    //}
    //}
    //}

    //} catch ( error ) {
    //setLoadingPage( false );
    //setCustomError( true );
    //setEmployerData( [] );
    //}
  };

  useEffect(() => {
    //if((searchText && searchText.length > 0) || currentPage > 1) {
    if (openDoctorMOdal) {
      searchDoctorsList(searchText, currentPage, facilityOIDProps);
    }
  }, [searchText, currentPage, facilityOIDProps]);

  return (
    <>
      {true ? (
        true ? (
          <button
            type="button"
            className="panel-card-link"
            onClick={(e) => handleAddDoctors(e, facilityOIDProps)}
          >
            Select Doctors
          </button>
        ) : (
          <button
            type="button"
            className="panel-card-link panel-card-link-disable"
          >
            Select Doctors
          </button>
        )
      ) : null}
      {!true ? (
        editAffiliatedRecords ? (
          <AddButton
            onClick={(e) => handleAddDoctors(e)}
            label={'Select Employer(s)'}
            className={'add-button-active'}
          />
        ) : (
          <AddButton
            label={'Select Employer(s)'}
            className={'add-button-disable'}
          />
        )
      ) : null}

      <FilterModal
        showBackButton={false}
        isVisible={openDoctorMOdal}
        onHide={() => {
          setSearchString('');
          setDoctorsAPIResponse(null);
          setDoctorsData([]);
          setOpenDoctorMOdal(false);
          setCustomError(false);
          setLoadingPage(true);
          setCurrentPage(1);
        }}
        applyFilterHandler={applyFilterHandler}
        showCancel={true}
        titleLabel="Doctors"
        showApply={true}
        showApplyLabel="Add Selected"
      >
        <Container className="mt-3 mb-3">
          <Row>
            <Col sm={12}>
              <div>
                <TextInput
                  parentClassName="mb-2"
                  label="Doctor"
                  append={
                    <InputGroup.Text>
                      <SearchSVG.SearchSVG className="primary-text-color" />
                    </InputGroup.Text>
                  }
                  inputProps={{
                    type: 'text',
                    placeholder: 'Search by Name, Specialty, Tax ID or NPI',
                    value: searchString,
                    onChange: onChangeDoctorsHandler,
                    className: 'border-right-0',
                    autoFocus: false,
                    id: 'filter-broker-input',
                  }}
                />
              </div>
            </Col>
          </Row>
          {loadingPage && !customError && <Skeleton count={10} />}
          {!loadingPage &&
            !customError &&
            doctorsData &&
            Object.keys(doctorsData).length > 0 && (
              <>
                <Row>
                  <Col sm={12} className="mt-4 mb-2">
                    <div className=" select-all-row d-flex">
                      <input
                        type="checkbox"
                        id="select-all-doctor"
                        name="select-all-doctor"
                        className="p-0 mt-auto mb-auto"
                        onChange={(e) => {
                          selectChangeHandler(e);
                        }}
                        checked={
                          doctorsData.filter((emp) => emp.isChecked !== true)
                            .length < 1
                        }
                      />
                      <label
                        className="my-auto select-all-checkbox"
                        htmlFor="select-all-doctor"
                      >
                        Select All
                      </label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} className="mb-1">
                    <Lists
                      data={doctorsData}
                      selectChangeHandler={selectChangeHandler}
                      facilityTaxIdProps={facilityTaxIdProps}
                      //searchString={searchString}
                    />
                  </Col>
                </Row>
                <Row className="mt-3 ml-1">
                  {!searchString &&
                  doctorsData &&
                  doctorsData.length <
                    doctorsAPIResponse.Pagination.TotalRecords ? (
                    <div
                      className="panel-card-link"
                      onClick={() => showMoreDoctorsData()}
                      role="button"
                    >
                      Show More
                    </div>
                  ) : null}
                  {userData?.UserType !== 'Provider' &&
                    searchString &&
                    doctorsData &&
                    doctorsData.length <
                      doctorsAPIResponse.Pagination.TotalRecords && (
                      <div
                        className="panel-card-link"
                        onClick={() => showMoreSearchDoctorsData()}
                        role="button"
                      >
                        Show More
                      </div>
                    )}
                </Row>
              </>
            )}
        </Container>
        {!loadingPage &&
          doctorsData &&
          Object.keys(doctorsData).length === 0 && (
            <Container className="mt-3 mb-3">
              <div>No Records Found</div>
            </Container>
          )}
      </FilterModal>
    </>
  );
};

export default DoctorsPanel;
